import axios from 'axios';
import React, { Component, useState } from 'react';
import './Footer.css';
const BASE_URL = 'https://testwire.wockhardt.com';

//const [message, setMessage] = useState("");
const jwt = localStorage.getItem('jwt'); // get the JWT token from local storage

const handleLogout = () => {
    // Clear token from local storage
    localStorage.removeItem('jwt');
    // Redirect to login page
    window.location.href = '/login';
  }

class Profile extends React.Component 
{
  state = {showDiv: false, data1: null,data2:null,responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',education:'',previousemployment:'',address:'',pan:'',aadhar:'',uan:'',contactno:'',designation:'',empcode:'',Gender:'',dob:'',positioN_CODE:'',position:'',area:'',subarea:'',subgroup:'',doj:'',companY_CODE:'',cosT_CENTER:'',worK_CNTRCT:'',organization:'',communication:'',flM_CODE:'',reP_MGR:'',peR_ADMIN:'',paY_ADMIN:'',orG_CODE:'',profileapproved:'',salutation:'',firstName:'',lastName:'',middleName:'',aadharName:'',officialEmail:'',personalMobile:'',bankName:'',bankAccountNo:'',ifsc:'',pfNo:'',passportNo:'',personalEmail:'',officeTelNo:'',officeMobile:'',password:'',submissionStatus:null,peR_ADMIN_CODE:'',peR_ADMIN_EMAIL:'',funC_HEAD_CODE:'',funC_HEAD_EMAIL:'',country:'',jobrole:''};

  fetchData0 = (userId) => 
  {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{headers: {Authorization: `Bearer ${jwt}`,'Content-Type': 'application/json'},})
    .then(res => {this.setState({ data0: res.data });console.log('API response user', res);})
    .catch(error => {console.error('API ERROR:', error);});
  };

  fetchData1 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        //console.log('API response for header-button:', res);
        this.setState({ data1: res.data });
      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        console.log(`API response for user data with id ${userId}:`, res);
        this.setState({ responseData: res.data });
        let username = res.data.username;
        let email = res.data.email;
        let job = res.data.job;
        let education = res.data.education;
        let previousemployment = res.data.previousemployment;
        let address = res.data.address;
        let pan = res.data.pan;
        let aadhar = res.data.aadhar;
        let uan = res.data.uan;
        let password = res.data.password;
        let contactno = res.data.contactno;
        let designation = res.data.designation;
        let empcode = res.data.empcode;
        let Gender = res.data.Gender;
        let dob = res.data.dob;
        let picture = res.data.picture.name;
        let pictureurl = res.data.picture.url;
        let positioN_CODE = res.data.positioN_CODE;
        let position = res.data.position;
        let area = res.data.area;
        let subarea = res.data.subarea;
        let subgroup = res.data.subgroup;
        let doj = res.data.doj;
        let companY_CODE = res.data.companY_CODE;
        let cosT_CENTER = res.data.cosT_CENTER;
        let worK_CNTRCT = res.data.worK_CNTRCT;
        let organization = res.data.organization;
        let communication = res.data.communication;
        let flM_CODE = res.data.flM_CODE;
        let reP_MGR = res.data.reP_MGR;
        let peR_ADMIN = res.data.peR_ADMIN;
        let paY_ADMIN = res.data.paY_ADMIN;
        let orG_CODE = res.data.orG_CODE;
        let country = res.data.country;
        let jobrole = res.data.jobrole;
        let profileapproved = res.data.profileapproved;
        let salutation = res.data.salutation;
        let lastName = res.data.lastName;
        let firstName = res.data.firstName;
        let middleName = res.data.middleName;
        let officialEmail = res.data.officialEmail;
        let personalMobile = res.data.personalMobile;
        let bankName = res.data.bankName;
        let bankAccountNo = res.data.bankAccountNo;
        let ifsc = res.data.ifsc;
        let aadharName = res.data.aadharName;
        let pfNo = res.data.pfNo;
        let passportNo = res.data.passportNo;
        let personalEmail = res.data.personalEmail;
        let officeTelNo = res.data.officeTelNo;
        let officeMobile = res.data.officeMobile;
        let peR_ADMIN_CODE = res.data.peR_ADMIN_CODE;
        let peR_ADMIN_EMAIL = res.data.peR_ADMIN_EMAIL;
        let funC_HEAD_CODE = res.data.funC_HEAD_CODE;
        let funC_HEAD_EMAIL = res.data.funC_HEAD_EMAIL;
        this.setState({ username });
        this.setState({ email });
        this.setState({ job });
        this.setState({ picture });
        this.setState({ pictureurl });
        this.setState({ education });
        this.setState({ previousemployment });
        this.setState({ address });
        this.setState({ pan });
        this.setState({ aadhar });
        this.setState({ uan });
        this.setState({ password });
        this.setState({ contactno });
        this.setState({ designation });
        this.setState({ empcode });
        this.setState({ Gender });
        this.setState({ dob });
        this.setState({ positioN_CODE });
        this.setState({ position });
        this.setState({ area });
        this.setState({ subarea });
        this.setState({ subgroup });
        this.setState({ doj });
        this.setState({ companY_CODE });
        this.setState({ cosT_CENTER });
        this.setState({ worK_CNTRCT });
        this.setState({ organization });
        this.setState({ communication });
        this.setState({ flM_CODE });
        this.setState({ reP_MGR });
        this.setState({ peR_ADMIN });
        this.setState({ peR_ADMIN_CODE });
        this.setState({ peR_ADMIN_EMAIL });
        this.setState({ funC_HEAD_CODE });
        this.setState({ funC_HEAD_EMAIL });
        this.setState({ paY_ADMIN });
        this.setState({ orG_CODE });
        this.setState({ country });
        this.setState({ jobrole });
        this.setState({ profileapproved });
        this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };
  

  /*updateUserData = (id, updatedData) => {
    axios.put(`${BASE_URL}/api/users/${id}`, updatedData,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
          },
    })
      .then(res => {
        console.log(`API response after updating user data with id ${id}:`, res);
        this.setState({ 
            responseData: res.data, 
            username: updatedData.username, 
            job: updatedData.job,
            education :updatedData.education,
            previousemployment :updatedData.previousemployment,
            address :updatedData.address,
            pan :updatedData.pan,
            uan :updatedData.uan,
            password :updatedData.password,
            aadhar :updatedData.aadhar,
            contactno :updatedData.contactno,
            designation :updatedData.designation,
            Gender : updatedData.Gender,
            dob : updatedData.dob,
            positioN_CODE : updatedData.positioN_CODE,
            position : updatedData.position,
            area : updatedData.area,
            subarea : updatedData.subarea,
            subgroup : updatedData.subgroup,
            doj : updatedData.doj,
            companY_CODE : updatedData.companY_CODE,
            cosT_CENTER : updatedData.cosT_CENTER,
            worK_CNTRCT : updatedData.worK_CNTRCT,
            organization : updatedData.organization,
            communication : updatedData.communication,
            flM_CODE : updatedData.flM_CODE,
            reP_MGR : updatedData.reP_MGR,
            peR_ADMIN : updatedData.peR_ADMIN,
            paY_ADMIN : updatedData.paY_ADMIN,
            orG_CODE: updatedData.orG_CODE,
            profileapproved :  updatedData.profileapproved
          });
          //setMessage("Data saved successfully.");

      })
      .catch(error => {
        console.error(`API error while updating user data with id ${id}:`, error);
        //setMessage("An error occurred. Please try again later.");
      });
  };*/

  /*updateUserData = (id, updatedData) => {
  if (!updatedData.hasOwnProperty("profileapproved")) {
    updatedData.profileapproved = false;
  }
    axios.put(`${BASE_URL}/api/users/${id}`, updatedData,{
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
        },
    })
    .then(res => {
        console.log(`API response after updating user data with id ${id}:`, res);
        let updatedData = res.data;
        if (updatedData.profileapproved === true) {
            updatedData.profileapproved = false;
        }
        this.setState({ 
            responseData: updatedData, 
            username: updatedData.username, 
            job: updatedData.job,
            education: updatedData.education,
            previousemployment: updatedData.previousemployment,
            address: updatedData.address,
            pan: updatedData.pan,
            uan: updatedData.uan,
            password : updatedData.password,
            aadhar: updatedData.aadhar,
            contactno: updatedData.contactno,
            designation: updatedData.designation,
            Gender: updatedData.Gender,
            dob: updatedData.dob,
            positioN_CODE: updatedData.positioN_CODE,
            position: updatedData.position,
            area: updatedData.area,
            subarea: updatedData.subarea,
            subgroup: updatedData.subgroup,
            doj: updatedData.doj,
            companY_CODE: updatedData.companY_CODE,
            cosT_CENTER: updatedData.cosT_CENTER,
            worK_CNTRCT: updatedData.worK_CNTRCT,
            organization: updatedData.organization,
            communication: updatedData.communication,
            flM_CODE: updatedData.flM_CODE,
            reP_MGR: updatedData.reP_MGR,
            peR_ADMIN: updatedData.peR_ADMIN,
            paY_ADMIN: updatedData.paY_ADMIN,
            orG_CODE: updatedData.orG_CODE,
            profileapproved: updatedData.profileapproved
        });
        //setMessage("Data saved successfully.");

    })
    .catch(error => {
        console.error(`API error while updating user data with id ${id}:`, error);
        //setMessage("An error occurred. Please try again later.");
    });
};*/

updateUserData = (id, updatedData) => {
    axios.put(`${BASE_URL}/api/users/${id}`, updatedData,{
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Content-Type': 'application/json'
      },
    })
      .then(res => {
        console.log(`API response after updating user data with id ${id}:`, res);
        this.setState({ 
          responseData: res.data, 
          username: updatedData.username, 
          job: updatedData.job,
          education: updatedData.education,
          previousemployment: updatedData.previousemployment,
          address: updatedData.address,
          pan: updatedData.pan,
          uan: updatedData.uan,
          password: updatedData.password,
          aadhar: updatedData.aadhar,
          contactno: updatedData.contactno,
          designation: updatedData.designation,
          Gender: updatedData.Gender,
          dob: updatedData.dob,
          positioN_CODE: updatedData.positioN_CODE,
          position: updatedData.position,
          area: updatedData.area,
          subarea: updatedData.subarea,
          subgroup: updatedData.subgroup,
          doj: updatedData.doj,
          companY_CODE: updatedData.companY_CODE,
          cosT_CENTER: updatedData.cosT_CENTER,
          worK_CNTRCT: updatedData.worK_CNTRCT,
          organization: updatedData.organization,
          communication: updatedData.communication,
          flM_CODE: updatedData.flM_CODE,
          reP_MGR: updatedData.reP_MGR,
          peR_ADMIN: updatedData.peR_ADMIN,
          peR_ADMIN_CODE: updatedData.peR_ADMIN_CODE,
          peR_ADMIN_EMAIL: updatedData.peR_ADMIN_EMAIL,
          funC_HEAD_CODE: updatedData.funC_HEAD_CODE,
          funC_HEAD_EMAIL: updatedData.funC_HEAD_EMAIL,
          paY_ADMIN: updatedData.paY_ADMIN,
          orG_CODE: updatedData.orG_CODE,
          country: updatedData.country,
          jobrole: updatedData.jobrole,
          profileapproved: updatedData.profileapproved,
          salutation :  updatedData.salutation,
            lastName :  updatedData.lastName,
            firstName :  updatedData.firstName,
            middleName :  updatedData.middleName,
            officialEmail :  updatedData.officialEmail,
            personalMobile :  updatedData.personalMobile,
            bankName :  updatedData.bankName,
            bankAccountNo :  updatedData.bankAccountNo,
            ifsc :  updatedData.ifsc,
            aadharName :  updatedData.aadharName,
            pfNo :  updatedData.pfNo,
            passportNo :  updatedData.passportNo,
            personalEmail :  updatedData.personalEmail,
            officeTelNo :  updatedData.officeTelNo,
            officeMobile :  updatedData.officeMobile,
            submissionStatus: 'success'
        });
        //setMessage("Data saved successfully.");
  
      })
      .catch(error => {
        console.error(`API error while updating user data with id ${id}:`, error);
        //setMessage("An error occurred. Please try again later.");
        this.setState({submissionStatus:'error',});
      });
  };
  


  componentDidMount() {
    this.fetchData1();
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    let username = jwtDataParsed.user.username;
    let email = jwtDataParsed.user.email;
    let job = jwtDataParsed.user.job;
    let education = jwtDataParsed.user.education;
    let previousemployment = jwtDataParsed.user.previousemployment;
    let address = jwtDataParsed.user.address;
    let pan = jwtDataParsed.user.pan;
    let aadhar = jwtDataParsed.user.aadhar;
    let uan = jwtDataParsed.user.uan;
    let password = jwtDataParsed.user.password;
    let contactno = jwtDataParsed.user.contactno;
    let designation = jwtDataParsed.user.designation;
    let empcode = jwtDataParsed.user.empcode;
    let Gender = jwtDataParsed.user.Gender;
    let dob = jwtDataParsed.user.dob;
    let positioN_CODE = jwtDataParsed.user.positioN_CODE;
    let position = jwtDataParsed.user.position;
    let area = jwtDataParsed.user.area;
    let subarea = jwtDataParsed.user.subarea;
    let subgroup = jwtDataParsed.user.subgroup;
    let doj = jwtDataParsed.user.doj;
    let companY_CODE = jwtDataParsed.user.companY_CODE;
    let cosT_CENTER = jwtDataParsed.user.cosT_CENTER;
    let worK_CNTRCT = jwtDataParsed.user.worK_CNTRCT;
    let organization = jwtDataParsed.user.organization;
    let communication = jwtDataParsed.user.communication;
    let flM_CODE = jwtDataParsed.user.flM_CODE;
    let reP_MGR = jwtDataParsed.user.reP_MGR;
    let peR_ADMIN = jwtDataParsed.user.peR_ADMIN;
    let peR_ADMIN_CODE = jwtDataParsed.user.peR_ADMIN_CODE;
    let peR_ADMIN_EMAIL = jwtDataParsed.user.peR_ADMIN_EMAIL;
    let funC_HEAD_CODE = jwtDataParsed.user.funC_HEAD_CODE;
    let funC_HEAD_EMAIL = jwtDataParsed.user.funC_HEAD_EMAIL;
    let paY_ADMIN = jwtDataParsed.user.paY_ADMIN;
    let orG_CODE = jwtDataParsed.user.orG_CODE;
    let country = jwtDataParsed.user.country;
    let jobrole = jwtDataParsed.user.jobrole;
    let profileapproved = jwtDataParsed.user.profileapproved;
    let salutation = jwtDataParsed.user.salutation;
        let lastName = jwtDataParsed.user.lastName;
        let firstName = jwtDataParsed.user.firstName;
        let middleName = jwtDataParsed.user.middleName;
        let officialEmail = jwtDataParsed.user.officialEmail;
        let personalMobile = jwtDataParsed.user.personalMobile;
        let bankName = jwtDataParsed.user.bankName;
        let bankAccountNo = jwtDataParsed.user.bankAccountNo;
        let ifsc = jwtDataParsed.user.ifsc;
        let aadharName = jwtDataParsed.user.aadharName;
        let pfNo = jwtDataParsed.user.pfNo;
        let passportNo = jwtDataParsed.user.passportNo;
        let personalEmail = jwtDataParsed.user.personalEmail;
        let officeTelNo = jwtDataParsed.user.officeTelNo;
        let officeMobile = jwtDataParsed.user.officeMobile;
    
    this.setState({ username });
    this.setState({ email });
    this.setState({ job });
    this.setState({ education });
    this.setState({ previousemployment });
    this.setState({ address });
    this.setState({ pan });
    this.setState({ aadhar });
    this.setState({ uan });
    this.setState({ password });
    this.setState({ contactno });
    this.setState({ designation });
    this.setState({ empcode });
    this.setState({ Gender });
    this.setState({ dob });
    this.setState({ id });
    if (id) {
      this.fetchData0(id);
    } else {
      console.error('id is undefined');
    }
    this.fetchUserData(id);
    this.setState({ positioN_CODE });
        this.setState({ position });
        this.setState({ area });
        this.setState({ subarea });
        this.setState({ subgroup });
        this.setState({ doj });
        this.setState({ companY_CODE });
        this.setState({ cosT_CENTER });
        this.setState({ worK_CNTRCT });
        this.setState({ organization });
        this.setState({ communication });
        this.setState({ flM_CODE });
        this.setState({ reP_MGR });
        this.setState({ peR_ADMIN });
        this.setState({ peR_ADMIN_CODE });
        this.setState({ peR_ADMIN_EMAIL });
        this.setState({ funC_HEAD_CODE });
        this.setState({ funC_HEAD_EMAIL });
        this.setState({ paY_ADMIN });
        this.setState({ orG_CODE});
        this.setState({ country});
        this.setState({ jobrole});
        this.setState({ profileapproved});
        this.setState({ salutation });
        this.setState({ lastName });
        this.setState({ firstName });
        this.setState({ middleName });
        this.setState({ officialEmail });
        this.setState({ personalMobile });
        this.setState({ bankName });
        this.setState({ bankAccountNo });
        this.setState({ ifsc });
        this.setState({ aadharName });
        this.setState({ pfNo });
        this.setState({ passportNo });
        this.setState({ personalEmail });
        this.setState({ officeTelNo });
        this.setState({ officeMobile });
  }

  handleClick = () => {
    this.setState({
      showDiv: !this.state.showDiv
    });
  };

  handleGenerateQR = () => {
    const { userId} = this.state.data0;
console.log('Test')
    const payload = {data: this.state.data0};
	  console.log(JSON.stringify(payload));;
console.log('QR Data');
	  console.log(payload);
    axios.post('https://vcqr.wockhardt.com/api/v1/dostemp', payload,{
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
     
  },})
      .then(response => {
        //console.log('QR generation response:', response);
        alert('Your request for eVisiting Card has been sent to Functional Head for Approval.');
      })
      .catch(error => {
        console.error('QR generation error:', error);
      });
  };

  handleInputChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    const name = event.target.name;
    this.setState({
        [event.target.name]: event.target.value,
      profileapproved: value === true ? "true" : "false" // convert the boolean value to a string
    });
  }

  render() {
    let updatedData = {
        username: this.state.username,
        job: this.state.job,
        education: this.state.education,
        address: this.state.address,
        previousemployment: this.state.previousemployment,
        pan: this.state.pan,
        aadhar: this.state.aadhar,
        uan: this.state.uan,
        password: this.state.password,
        contactno: this.state.contactno,
        designation: this.state.designation,
        Gender: this.state.Gender,
        dob:this.state.dob,
        positioN_CODE:this.state.positioN_CODE,
        position:this.state.position,
        area:this.state.area,
        subarea:this.state.subarea,
        subgroup:this.state.subgroup,
        doj:this.state.doj,
        companY_CODE:this.state.companY_CODE,
        cosT_CENTER:this.state.cosT_CENTER,
        worK_CNTRCT:this.state.worK_CNTRCT,
        organization:this.state.organization,
        communication:this.state.communication,
        flM_CODE:this.state.flM_CODE,
        reP_MGR:this.state.reP_MGR,
        peR_ADMIN:this.state.peR_ADMIN,
        peR_ADMIN_CODE:this.state.peR_ADMIN_CODE,
        peR_ADMIN_EMAIL:this.state.peR_ADMIN_EMAIL,
        funC_HEAD_CODE:this.state.funC_HEAD_CODE,
        funC_HEAD_EMAIL:this.state.funC_HEAD_EMAIL,
        paY_ADMIN:this.state.paY_ADMIN,
        orG_CODE:this.state.orG_CODE,
        country:this.state.country,
        jobrole:this.state.jobrole,
        profileapproved:this.state.profileapproved,
        salutation:this.state.salutation,
        firstName:this.state.firstName,
        lastName:this.state.lastName,
        middleName:this.state.middleName,
        officialEmail:this.setState.officialEmail,
        personalMobile:this.setState.personalMobile,
        bankName:this.setState.bankName,
        bankAccountNo:this.setState.bankAccountNo,
        ifsc:this.setState.ifsc,
        aadharName:this.setState.aadharName,
        pfNo:this.setState.pfNo,
        passportNo:this.setState.passportNo,
        personalEmail:this.setState.personalEmail,
        officeTelNo:this.setState.officeTelNo,
        officeMobile:this.setState.officeMobile
      };
      let submissionMessage;
      if (this.state.submissionStatus === 'success'){
      submissionMessage=<div classname="text-green-500">Request Submitted Successfully!</div>;
      }else if (this.state.submissionStatus === 'error'){
      submissionMessage=<div classname="text-red-500">Error Submitting Request. Please try again.</div>;
      }
    if (this.state.data1 === null || this.state.responseData === null) 
    {
      return <div>Loading...</div>;
    }
    return (
        <div className='bg-silver1'>
            <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
                <div className="flex justify-between mb-2" > 
                    <div className='mt-3 ml-5'>
                        <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
                    </div>
                    <div className='flex'>
                        <ul class="navbar-list">
                     <li>
                                          <img style={{marginTop:5, marginRight:5,cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://testwire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.picture.alternativeText}  class="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white"  onClick={this.handleClick} />
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {this.state.username} </h5>
                                  <span class="text-white text-xs">{this.state.email}</span>
                                  <p class="text-white text-xs">{this.state.empcode}</p>
                                 </div>
                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                    {/*<a class="iq-bg-danger iq-sign-btn" href="/login" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i class="ri-login-box-line ml-2"></i></a>*/}
                                <a className="iq-bg-danger iq-sign-btn" href="/generateevisitingcard" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate eVisitingCard<i className="ri-login-box-line ml-2"></i></a>    
				<a className="iq-bg-danger iq-sign-btn" href="#" role="button" onClick={handleLogout} style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i className="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                        </ul>
                    </div>
                </div>
                {/*<div style={{ display: 'flex', flexWrap: 'wrap', justifyContent:'space-around'  }} >  */}
                <div style={{ display: 'flex',  justifyContent:'space-around'  }} >  
                    {this.state.data1.data.map(item => (
                        <div  className="mb-1">
                            <div className="col-md-4" key={item.id}>
                                <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bg-silver1 pt-32'/>  

            <div className='bg-silver1'>
                <section>     
                    <div className="bg-silver1">
                        <div className='lg:flex justify-around mx-4'>
                            {/*<div className='bg-white rounded-2xl p-4 my-4 lg:my-0 shadow-xl' style={{background:'#effafe', marginBottom:0, position:"relative", borderRadius:25, paddingTop:30,paddingBottom:30,paddingLeft:60,paddingRight:60,width:'40%', fontSize:16, fontWeight:400 }}> */}
                            <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 shadow-xl lg:w-[100%]' style={{background:'#fff', marginBottom:20, position:"relative", borderRadius:25, fontSize:16, fontWeight:400 }}>
                                <div className='justify-between'> 
                                    {/*<form className="mt-4">*/}
                                        <div className="form-group">
                                            <div>
                                            {/*<img class="h-[50px] rounded-3xl" src={`https://testwire.wockhardt.com${this.state.pictureurl}`} alt={this.state.picture.alternativeText} style={{ display: 'block', margin: 'auto', borderWidth:2, borderColor:'#0f90c0' }} />*/}
                                            
                                                              <img class="h-[50px] rounded-3xl" style={{margin: 'auto',cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://testwire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.picture.alternativeText}  class="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white" /></div>
                                        </div>
                                       
                                       <div className='lg:flex justify-around'>
                                            <div>
                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Gender</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="Gender" placeholder="Enter Gender" value={this.state.Gender} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>
                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Salutation</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="salutation" placeholder="Enter Salutation" value={this.state.salutation} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Last Name</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="lastName" placeholder="Enter Last Name" value={this.state.lastName} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>First Name</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="firstName" placeholder="Enter your First Name" value={this.state.firstName} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                        </div>
                                        
                                        <div className='lg:flex justify-around'>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Middle Name</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="middleName" placeholder="Enter Middle Name" value={this.state.middleName} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Date of Birth</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="dob" placeholder="Enter your Date of Birth" value={this.state.dob} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>PAN No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="pan" placeholder="Enter your PAN No" value={this.state.pan} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Aadhar No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="aadhar" placeholder="Enter your Aadhar No" value={this.state.aadhar} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                        </div>
                                        
                                       
                                        <div className='lg:flex justify-around'>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>UAN No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="uan" placeholder="Enter your UAN No" value={this.state.uan} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Official Email</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="email" placeholder="Enter your Official Email" value={this.state.email} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Personal Cell No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="personalMobile" placeholder="Enter your Personal Mobile No" value={this.state.personalMobile} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Bank Name</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="bankName" placeholder="Enter your Bank Name" value={this.state.bankName} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                        </div>
                                        
                                      
                                        
                                        <div className='lg:flex justify-around'>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Bank Account No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="bankAccountNo" placeholder="Enter your bank Account No" value={this.state.bankAccountNo} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>IFSC Code</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="ifsc" placeholder="Enter your IFSC Code" value={this.state.ifsc} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Name as per Aadhar</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="aadharName" placeholder="Enter your Name as per Aadhar" value={this.state.aadharName} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>PF No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="pfNo" placeholder="Enter your PF No" value={this.state.pfNo} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                        </div>
                                        
                                        
                                        <div className='lg:flex justify-around'>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Passport Details</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="passportNo" placeholder="Enter your Passport Details" value={this.state.passportNo} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Personal Email Id</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="personalEmail" placeholder="Enter your Personal Email Id" value={this.state.personalEmail} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Official Telephone No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="officeTelNo" placeholder="Enter your Office Telephone No" value={this.state.officeTelNo} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Offical Contact No</label>
                                                </div>
                                                <div className="form-group text-xs" style={{ display:'flex', flexDirection:'row', alignItems:'center', width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{ flex:1, background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="officeMobile" placeholder="Enter your Official Contact No" value={this.state.officeMobile} onChange={this.handleInputChange} />
                                                    <a href="/newcontact">
                                                    	<img style={{ width:'10px', height:'10px' }} src="https://testwire.wockhardt.com/uploads/edit-img.png" alt="Update Number" title="Update Number" />
                                                    </a>
                                                </div>  
                                            </div>
                                        </div>
                                        
                                        <div className='lg:flex justify-around'>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Admin Code</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="passportNo" placeholder="Enter your Admin Code" value={this.state.peR_ADMIN_CODE} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Admin Email Id</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="peR_ADMIN_EMAIL" placeholder="Enter your Admin Email Id" value={this.state.peR_ADMIN_EMAIL} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Functional Head Code</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="funC_HEAD_CODE" placeholder="Enter your Functional Head Code" value={this.state.funC_HEAD_CODE} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            <div>

                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Functional Head Email</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="funC_HEAD_EMAIL" placeholder="Enter your Functional Head Email" value={this.state.funC_HEAD_EMAIL} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                        </div>
                                        
                                        <div className='lg:flex justify-around'>
                                        
                                        <div>
                                        <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                           <label for="exampleInputPassword1" style={{display:"inline-block"}}>Designation</label>
                                        </div>
                                        <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                           <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="jobrole" placeholder="Enter your Job Role" value={this.state.jobrole} onChange={this.handleInputChange} />
                                        </div>
				        </div>                        
                                        
                                        <div>
                                        <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                           <label for="exampleInputPassword1" style={{display:"inline-block"}}>Country</label>
                                        </div>
                                        <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                           <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="country" placeholder="Enter your Country" value={this.state.country} onChange={this.handleInputChange} />
                                        </div>
                     			</div>

                                                <div>
                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Password</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="password" placeholder="Enter your Password" value={this.state.password} onChange={this.handleInputChange} />
                                                </div>  
                                            </div>
                                            
                                            </div>
                                        
                                       
                                        <div style={{ visibility: 'hidden' }}>
                                                {/* Profile Approval */}
                                                <div className="form-group text-xs" style={{marginTop:10, fontWeight:400 }}>
                                                    <label for="exampleInputPassword1" style={{display:"inline-block"}}>Profile Approved</label>
                                                </div>
                                                <div className="form-group text-xs" style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:6,paddingRight:12,paddingLeft:12,paddingBottom:6,fontWeight:400,borderRadius:4 }}>
                                                    <input className='text-xs' style={{width:'100%', background:'#eee', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="profileapproved" placeholder="Enter your ORG Code" value={this.state.profileapproved} onChange={this.handleInputChange} />
                                                    {/*<input className='text-xs' style={{width:'100%', background:'#ffffff', marginBottom:0,paddingTop:2,paddingBottom:2,fontWeight:400,borderRadius:4 }} type="text" name="profileapproved" placeholder="Enter your ORG Code" value={false} onChange={this.handleInputChange} />*/}
                                                </div> 
                                            </div>
                                            <div style={{textAlign:'center'}} >
                                        <button className='bg-blue btn btn-primary text-xs' style={{padding:10,color:'#fff',borderRadius:5}} type="button" onClick={() => this.updateUserData(this.state.id,updatedData, { profileapproved: this.state.profileapproved })}>Update</button>
                                        
                                       
                                        
                                        </div>
                                        
                                        <div className='bg-silver1'>
                                         <div style={{textAlign:'center',marginTop:'10px'}}>{submissionMessage}</div>
                                        </div>

                                        {/*{message && <p class="message">{message}</p>}*/}
                                    {/*</form>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/*<section>
                    <div className=" bg-darkblue sticky left-[0] bottom-[0] right-[0]">
                        <div className=' text-metal lg:flex lg:justify-between lg:mx-2 lg:pl-3 mx-2 '>
                            <div className=''/>
                            <div>
                                <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-white'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
                            </div>
                        </div>
                    </div>
                </section>*/}
                <section>
                    <div className="footer">
                        <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 pr-3 text-xs text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
                    </div>
                </section>
            </div>
        </div>
    );
  }
}
export default Profile;
